/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Field, FieldArray, useFormikContext } from 'formik';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { useMutation } from '@apollo/client';
import {
  DELETE_ORDER_LOGISTICS,
  UPDATE_ORDER_STATUS,
} from 'pages/Orders/OrdersGraphQL';
import { calculatePendingQty, processLogistics } from 'pages/Orders/constant';
import CountryField from 'components/CountryField';
import FormikInputField from 'components/Fields/FormikInputField';
import StateField from 'components/StateField';
import S3FileUploadField from 'components/S3FileUploadField';
import EditUploadWrapper from 'components/EditUploadWrapper';
import CallingCodeField from 'components/CallingCodeField';
import CommonAccordion from 'components/common/CommonAccordion';
import ButtonV2 from 'components/common/ButtonV2';
import FormikRadioGroupField from 'components/Fields/FormikRadioGroupField';
import CardWithTitleAndButton from 'components/CardWithTitleAndButton';
import FormikDatePicker from 'components/Fields/FormikDatePicker';
import { axiosGetAPI, axiosPost, axiosUpdate } from 'services';
import { authContext } from 'contexts/AuthContext';
import ReactSelect from 'components/Fields/ReactSelect';

import {
  getOrderDraft,
  setOrderDraft,
  clearOrderDraft,
} from 'pages/Orders/orderDraftStore';
// import CityField from 'components/CityField';
import DeliveryField from './DeliveryField';

const isValidVehicleNumberPrefix = (value) =>
  [
    /^[A-Za-z]{0,2}$/,
    /^[A-Za-z]{2}\d{0,2}$/,
    /^[A-Za-z]{2}\d{2}[A-Za-z]{0,2}$/,
    /^[A-Za-z]{2}\d{2}[A-Za-z]{2}\d{0,4}$/,
  ].some((pattern) => pattern.test(value));

// GraphQL returns business-validation messages inside `extensions`/`exception`.
// Prefer those over Apollo's wrapper message so the user sees the API validation
// text, for example: "Please complete all required fields".
const getApiErrorMessage = (error, fallback) => {
  const graphQLError = error?.graphQLErrors?.[0];
  return (
    graphQLError?.extensions?.errorMessage ||
    graphQLError?.exception?.message ||
    graphQLError?.message ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  );
};

const cloudIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00098 0.249512C6.68222 0.249512 8.07858 1.49995 8.23047 3.11182C9.22528 3.25254 10.0009 4.08559 10.001 5.10791C10.001 6.23041 9.06504 7.12451 7.93066 7.12451H2.36426C1.06878 7.12434 0.000976562 6.10363 0.000976562 4.82373C0.000980214 3.72194 0.792466 2.80897 1.83984 2.57764C1.92933 2.0384 2.27626 1.50077 2.75488 1.08838C3.37944 0.549817 4.1763 0.252211 5.00098 0.249512ZM5.00098 0.874512C4.32607 0.87732 3.67412 1.12114 3.16309 1.56201C2.6901 1.9701 2.44238 2.46223 2.44238 2.84717V3.12646L2.16504 3.15771C1.29192 3.25334 0.62598 3.96998 0.625977 4.82373C0.625977 5.7405 1.39503 6.49934 2.36426 6.49951H7.93066C8.73879 6.49951 9.37598 5.86729 9.37598 5.10791C9.37586 4.348 8.73872 3.71533 7.93066 3.71533H7.61816V3.40283C7.61863 2.01546 6.45588 0.874512 5.00098 0.874512ZM5.00098 2.12451C5.042 2.12451 5.08319 2.13226 5.12109 2.14795C5.15906 2.1637 5.19363 2.18721 5.22266 2.21631L6.47266 3.46631C6.50171 3.49536 6.52529 3.52991 6.54102 3.56787C6.5566 3.60561 6.56439 3.64618 6.56445 3.68701C6.56445 3.72801 6.55667 3.76924 6.54102 3.80713C6.52529 3.84509 6.50171 3.87964 6.47266 3.90869C6.4436 3.93775 6.40906 3.96133 6.37109 3.97705C6.3332 3.99271 6.29197 4.00049 6.25098 4.00049C6.21015 4.00043 6.16957 3.99264 6.13184 3.97705C6.09388 3.96133 6.05933 3.93774 6.03027 3.90869L5.31348 3.19189V5.56201C5.31348 5.64489 5.28126 5.72509 5.22266 5.78369C5.16405 5.8423 5.08386 5.87451 5.00098 5.87451C4.91827 5.87439 4.83876 5.84218 4.78027 5.78369C4.72167 5.72509 4.68848 5.64489 4.68848 5.56201V3.19189L3.97266 3.90869C3.91398 3.96737 3.83396 4.00049 3.75098 4.00049C3.66817 4.00036 3.58884 3.96725 3.53027 3.90869C3.47159 3.85001 3.43848 3.77 3.43848 3.68701C3.4386 3.6042 3.47171 3.52488 3.53027 3.46631L4.78027 2.21631C4.8093 2.18721 4.84387 2.1637 4.88184 2.14795C4.91958 2.13232 4.96013 2.12457 5.00098 2.12451Z"
      fill="#212529"
    />
  </svg>
);

const doneCloudIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.50098 0.249512C7.18222 0.249512 8.57858 1.49933 8.73047 3.11182C9.72528 3.25254 10.5009 4.08559 10.501 5.10791C10.501 6.23104 9.56504 7.12451 8.43066 7.12451H2.86426C1.56878 7.12434 0.500977 6.10363 0.500977 4.82373C0.50098 3.72194 1.29247 2.80897 2.33984 2.57764C2.42932 2.0384 2.77626 1.50077 3.25488 1.08838C3.87944 0.549817 4.6763 0.252211 5.50098 0.249512ZM6.75098 2.74951C6.66816 2.74964 6.58884 2.78274 6.53027 2.84131L4.87598 4.49561L4.16016 3.77881C4.1311 3.74975 4.09656 3.72617 4.05859 3.71045C4.0207 3.69479 3.97948 3.68701 3.93848 3.68701C3.89765 3.68707 3.85707 3.69486 3.81934 3.71045C3.78137 3.72617 3.74683 3.74975 3.71777 3.77881C3.68872 3.80786 3.66514 3.84241 3.64941 3.88037C3.63382 3.91811 3.62604 3.95868 3.62598 3.99951C3.62598 4.04051 3.63376 4.08174 3.64941 4.11963C3.66514 4.15759 3.68872 4.19214 3.71777 4.22119L4.65527 5.15869C4.6843 5.18779 4.71888 5.2113 4.75684 5.22705C4.79458 5.24267 4.83513 5.25043 4.87598 5.25049C4.91699 5.25049 4.9582 5.24274 4.99609 5.22705C5.03406 5.2113 5.06863 5.18779 5.09766 5.15869L6.97266 3.28369C7.03134 3.22501 7.06445 3.145 7.06445 3.06201C7.06433 2.9792 7.03122 2.89987 6.97266 2.84131C6.91398 2.78263 6.83396 2.74951 6.75098 2.74951Z"
      fill="#212529"
    />
  </svg>
);

const OrderLogistics = ({
  values,
  handleChange,
  orderData,
  setFieldValue,
  validateForm,
  submitForm,
  refetchOrderData,
  onOrderUpdated = () => {},
  ...rest
}) => {
  // const [generateInvoice] = useLazyQuery(GENERATE_INVOICE, {
  //   fetchPolicy: 'network-only',
  // });
  // const [cancelInvoice] = useLazyQuery(CANCEL_INVOICE, {});

  const { auth } = useContext(authContext);

  const { setFieldTouched } = useFormikContext();
  const [sectionSaving, setSectionSaving] = useState(null);
  const [processingInvoiceId, setProcessingInvoiceId] = React.useState(null);
  const hasInitializedDefaultVehicle = useRef(false);

  // const [deleteOrderLogisticStatus] = useMutation(DELETE_ORDER_LOGISTICS, {
  //   // eslint-disable-next-line no-shadow
  //   onCompleted: ({ deleteOrderLogisticStatus }) => {
  //     toast.success(deleteOrderLogisticStatus);
  //   },

  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.map(({ message }) => {
  //       toast.error(message);
  //     });
  //   },
  // });
  const [updateOrderStatus] = useMutation(UPDATE_ORDER_STATUS);

  const paymentStatusInfo = [
    {
      id: 'PENDING',
      label: 'Pending',
    },
    {
      id: 'PAID',
      label: 'Paid',
    },
  ];

  // const downloadPDF = (base64String, filename) => {
  //   const linkSource = `data:application/pdf;base64,${base64String}`;
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = linkSource;
  //   downloadLink.download = filename;
  //   downloadLink.click();
  // };

  // const handleGenerateInvoice = async (orderLogisticId) => {
  //   const { data } = await generateInvoice({ variables: { orderLogisticId } });
  //   const base64String = data?.generateInvoice;
  //   const filename = 'invoice.pdf';
  //   downloadPDF(base64String, filename);
  // };

  // const handleCancelInvoice = async (orderLogisticId) => {
  //   const { data } = await cancelInvoice({ variables: { orderLogisticId } });
  //   toast.success(data.cancelInvoice);
  // };

  const getOrderInvoices = async (orderId, explicitLogistics = null) => {
    if (!orderId) return;
    try {
      const resp = await axiosGetAPI(
        `${process.env.REACT_APP_REST_API_ENDPOINT}invoice/${orderId}`,
        auth,
      );
      if (resp?.isSuccessful && resp?.data?.data) {
        const targetLogistics =
          explicitLogistics || values?.orderLogistics || [];
        const invoices = resp.data.data;
        const currentDraft = getOrderDraft(values?.id);
        setFieldValue(
          'invoiceInfo',
          targetLogistics.map((logistic, idx) => {
            const savedInvoice = invoices.find(
              (invoice) => String(invoice?.logisticId) === String(logistic?.id),
            );
            const existingInvoice =
              values?.invoiceInfo?.[idx] || currentDraft?.invoiceInfo?.[idx];
            if (savedInvoice) {
              let parsedFiles = null;
              if (savedInvoice?.invoiceFiles) {
                if (Array.isArray(savedInvoice.invoiceFiles)) {
                  parsedFiles = savedInvoice.invoiceFiles;
                } else if (typeof savedInvoice.invoiceFiles === 'string') {
                  try {
                    parsedFiles = JSON.parse(savedInvoice.invoiceFiles);
                  } catch (e) {
                    parsedFiles = [savedInvoice.invoiceFiles];
                  }
                } else {
                  parsedFiles = [savedInvoice.invoiceFiles];
                }
              }
              return {
                paymentStatus:
                  existingInvoice?.paymentStatus ||
                  (paymentStatusInfo?.find(
                    (x) => x?.id === savedInvoice?.paymentStatus,
                  ) ??
                    (savedInvoice?.paymentStatus
                      ? {
                          id: savedInvoice.paymentStatus,
                          label:
                            savedInvoice.paymentStatus === 'PAID'
                              ? 'Paid'
                              : 'Pending',
                        }
                      : null)),
                order: values?.id,
                id: savedInvoice?.id,
                invoiceFiles: existingInvoice?.invoiceFiles || parsedFiles,
                total: existingInvoice?.total ?? savedInvoice?.total ?? null,
                releasedToUser: savedInvoice?.releasedToUser,
                logisticId: logistic?.id,
                invoiceDetailsSaved: true,
              };
            }
            return (
              existingInvoice || {
                paymentStatus: null,
                order: values?.id,
                id: null,
                invoiceFiles: null,
                total: null,
                releasedToUser: null,
              }
            );
          }),
        );
      }
    } catch (error) {
      console.error('Error fetching Invoices in OrderLogistics:', error);
    }
  };

  const handleInvoiceFileUpload = (ind, uploadedUrls) => {
    const files = Array.isArray(uploadedUrls)
      ? uploadedUrls
      : uploadedUrls
        ? [uploadedUrls]
        : [];

    if (!files.length) return;

    setFieldValue(`invoiceInfo.${ind}`, {
      ...(values?.invoiceInfo?.[ind] || {}),
      invoiceFiles: files,
      invoiceDetailsSaved: false,
    });
    toast.success('Invoice file uploaded. Save invoice details to continue.');
  };

  useEffect(() => {
    if (values?.id) {
      getOrderInvoices(values.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.id, values?.orderLogistics?.map((l) => l?.id).join(',')]);

  // Sync vehicle form and logistics draft so it stays across tabs and sidebar navigation until browser refresh
  useEffect(() => {
    if (!values?.id) return;
    if (!values?.orderLogistics || values.orderLogistics.length === 0) return;
    setOrderDraft(values.id, {
      orderLogistics: values.orderLogistics,
      invoiceInfo: values.invoiceInfo,
    });
  }, [values?.id, values?.orderLogistics, values?.invoiceInfo]);

  useEffect(() => {
    if (hasInitializedDefaultVehicle.current) return;
    if (!values?.id) return;
    if ((values?.orderLogistics || []).length > 0) {
      hasInitializedDefaultVehicle.current = true;
      return;
    }

    hasInitializedDefaultVehicle.current = true;
    setFieldValue('orderLogistics', [
      {
        id: null,
        order: values?.id,
        driverName: '',
        driverNumber: '',
        vehicle: '',
        vehicleNumber: '',
        transportName: '',
        transportLR: '',
        loadingCharges: null,
        otherCharges: null,
        freight: null,
        rateUnit: values?.rateUnit?.id,
        weightSlipDoc: [],
        lrDoc: [],
        vehicleNumberImage: [],
        loadingImage: [],
        orderLogisticStatus: values?.status,
        loadingDate: null,
        dispatchDate: null,
        deliveryDate: null,
        loadingQty: '',
        loadingQtyUnit: values?.quantityUnit?.id,
        pickupAddress: {
          houseNumber: '',
          street: '',
          area: '',
          city: '',
          state: '',
          country: '',
          pinCode: '',
        },
      },
    ]);
    setFieldValue('invoiceInfo', [
      {
        paymentStatus: null,
        order: values?.id,
        id: null,
        invoiceFiles: null,
        total: null,
        releasedToUser: null,
      },
    ]);
  }, [
    setFieldValue,
    values?.id,
    values?.invoiceInfo,
    values?.orderLogistics,
    values?.quantityUnit?.id,
    values?.rateUnit?.id,
    values?.status,
  ]);

  const saveOneLogisticForm = async (ind) => {
    try {
      setSectionSaving(ind);
      const payload = processLogistics(JSON.parse(JSON.stringify(values)), ind);
      const selectedOrderStatus =
        values?.orderLogistics?.[ind]?.orderLogisticStatus;
      const resp = await axiosPost(
        `${process.env.REACT_APP_REST_API_ENDPOINT}order/create-or-update-process-order-logistics/${values?.id}`,
        payload,
        {},
        auth,
      );
      if (resp?.isSuccessful) {
        const savedLogisticId = resp?.data?.data;

        // Show the logistics API backend response as the Save toast
        const logisticsMessage =
          resp?.data?.message || 'Order Logistics Processed Successfully';

        // Update status only if it actually changed
        let statusMessage = null;
        if (selectedOrderStatus && selectedOrderStatus !== values?.status) {
          const deliveredQty = Math.round(
            Number(
              values?.quantity ||
                orderData?.order?.quantity ||
                values?.orderLogistics?.[ind]?.loadingQty ||
                0,
            ),
          );

          if (
            selectedOrderStatus === 'DELIVERED' &&
            (!deliveredQty || deliveredQty <= 0)
          ) {
            toast.error('Please enter valid delivered quantity');
            return;
          }

          const statusResponse = await updateOrderStatus({
            variables: {
              id: values?.id,
              status: selectedOrderStatus,
              deliveredQuantity:
                selectedOrderStatus === 'DELIVERED' ? deliveredQty : null,
            },
          });
          statusMessage = statusResponse?.data?.updateOrderStatus;
        }

        const updatedLogistics = values?.orderLogistics?.map(
          (logistic, index) => {
            if (index === ind) {
              return {
                ...logistic,
                id: savedLogisticId,
              };
            }
            return {
              ...logistic,
            };
          },
        );

        setFieldValue('orderLogistics', updatedLogistics);

        const hasRemainingUnsaved = updatedLogistics.some((l) => !l.id);
        if (!hasRemainingUnsaved) {
          clearOrderDraft(values?.id);
        } else {
          setOrderDraft(values?.id, {
            orderLogistics: updatedLogistics,
            invoiceInfo: values?.invoiceInfo,
          });
        }

        const invoiceInfo = values?.invoiceInfo?.[ind]
          ? JSON.parse(JSON.stringify(values.invoiceInfo[ind]))
          : null;

        const invoiceFiles = Array.isArray(invoiceInfo?.invoiceFiles)
          ? invoiceInfo?.invoiceFiles
          : invoiceInfo?.invoiceFiles
            ? [invoiceInfo?.invoiceFiles]
            : [];

        // Keep uploaded files as a draft until the user saves the logistics form.
        const hasNewInvoiceData =
          invoiceInfo?.total ||
          invoiceInfo?.paymentStatus ||
          invoiceFiles.length > 0;

        if (!hasNewInvoiceData) {
          // No new invoice changes — just show the logistics save toast
          toast.success(statusMessage || logisticsMessage);
          onOrderUpdated();
          return;
        }

        const paymentStatus =
          invoiceInfo?.paymentStatus?.id || invoiceInfo?.paymentStatus || null;

        const invoicePayload = {
          paymentStatus: paymentStatus || null,
          order: String(values?.id),
          logisticId:
            savedLogisticId || values?.orderLogistics?.[ind]?.id || null,
          id: invoiceInfo?.id || null,
          invoiceFiles: invoiceFiles.length > 0 ? invoiceFiles : [],
          total: invoiceInfo?.total ? String(invoiceInfo?.total) : null,
        };

        const invoiceResp = await axiosPost(
          `${process.env.REACT_APP_REST_API_ENDPOINT}invoice`,
          invoicePayload,
          {},
          auth,
        );

        if (invoiceResp?.isSuccessful) {
          const updatedInvoiceId = invoiceResp?.data?.data;

          let responseInvoiceFiles = invoicePayload.invoiceFiles;
          if (invoiceResp?.data?.data?.invoiceFiles) {
            const backendFiles = invoiceResp.data.data.invoiceFiles;
            if (Array.isArray(backendFiles)) {
              responseInvoiceFiles = backendFiles;
            } else if (typeof backendFiles === 'string') {
              try {
                responseInvoiceFiles = JSON.parse(backendFiles);
              } catch (e) {
                responseInvoiceFiles = [backendFiles];
              }
            }
          }

          setFieldValue(
            'invoiceInfo',
            values?.invoiceInfo?.map((invoice, index) => {
              if (index === ind) {
                return {
                  ...invoice,
                  id: updatedInvoiceId,
                  logisticId: savedLogisticId,
                  invoiceFiles: responseInvoiceFiles,
                  paymentStatus: paymentStatus
                    ? paymentStatusInfo.find((p) => p.id === paymentStatus) || {
                        id: paymentStatus,
                        label: paymentStatus === 'PAID' ? 'Paid' : 'Pending',
                      }
                    : null,
                  total: invoiceInfo?.total ?? null,
                  invoiceDetailsSaved: true,
                };
              }
              return invoice;
            }),
          );
          // Show logistics message (not invoice message) as the final toast
          toast.success(statusMessage || logisticsMessage);
          onOrderUpdated();
        } else {
          const invoiceErrorMsg =
            invoiceResp?.data?.message ||
            invoiceResp?.message ||
            'Failed to save invoice details';
          toast.error(invoiceErrorMsg);
        }
      } else {
        const errorMsg =
          resp?.data?.message ||
          resp?.message ||
          'Failed to process order logistics';
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error(error);
      const errorMsg = getApiErrorMessage(
        error,
        'Failed to process order logistics',
      );
      toast.error(errorMsg);
    } finally {
      setSectionSaving(null);
      await refetchOrderData();
    }
  };

  const onClickSave = async (ind) => {
    try {
      if (!values?.invoiceInfo?.[ind]) {
        setFieldValue(`invoiceInfo.${ind}`, {
          paymentStatus: null,
          order: values?.id,
          id: null,
          invoiceFiles: null,
          total: null,
          releasedToUser: null,
        });
      }
      setFieldTouched(`orderLogistics.${ind}.loadingQty`, true, true);
      setFieldTouched(`orderLogistics.${ind}.vehicleNumberImage`, true, true);
      setFieldTouched(`orderLogistics.${ind}.loadingImage`, true, true);
      setFieldTouched(`orderLogistics.${ind}.vehicleNumber`, true, true);
      setFieldTouched(`orderLogistics.${ind}.orderLogisticStatus`, true, true);

      const selectedStatus = values?.orderLogistics?.[ind]?.orderLogisticStatus;
      const currentInvoiceFiles = values?.invoiceInfo?.[ind]?.invoiceFiles;
      const hasCurrentInvoiceFile = Array.isArray(currentInvoiceFiles)
        ? currentInvoiceFiles.length > 0
        : Boolean(currentInvoiceFiles);
      const hasAnyInvoiceFile = values?.invoiceInfo?.some((inv) =>
        Array.isArray(inv?.invoiceFiles)
          ? inv.invoiceFiles.length > 0
          : Boolean(inv?.invoiceFiles),
      );
      const hasInvoiceFile = hasCurrentInvoiceFile || hasAnyInvoiceFile;

      if (
        (selectedStatus === 'DISPATCHED' || selectedStatus === 'DELIVERED') &&
        !hasInvoiceFile
      ) {
        setFieldTouched(`invoiceInfo.${ind}.invoiceFiles`, true, true);
        toast.error('Please Upload Invoice File');
        return;
      }

      const errors = await validateForm();
      const hasLogisticErrors = Boolean(
        errors?.orderLogistics?.[ind] &&
        Object.keys(errors.orderLogistics[ind]).length > 0,
      );
      const hasInvoiceErrors = Boolean(
        errors?.invoiceInfo?.[ind] &&
        Object.keys(errors.invoiceInfo[ind]).length > 0,
      );

      if (hasLogisticErrors || hasInvoiceErrors) {
        // trigger validation for the form
        submitForm();
        setTimeout(() => {
          const errorElement = document.querySelector('.is-invalid');
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }, 100);
      } else {
        saveOneLogisticForm(ind);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const releaseInvoice = async (invoiceId, index) => {
    try {
      setProcessingInvoiceId(invoiceId);
      const res = await axiosUpdate(
        `${process.env.REACT_APP_REST_API_ENDPOINT}invoice/release-invoice/${invoiceId}`,
        {},
        auth?.data?.token,
      );

      if (res?.isSuccessful) {
        toast.success('Invoice released to user successfully.');
        setFieldValue(
          'invoiceInfo',
          values?.invoiceInfo?.map((invoice, ind) => {
            if (index === ind) {
              return {
                ...invoice,
                releasedToUser: true,
              };
            }
            return {
              ...invoice,
            };
          }),
        );
      }
    } catch (error) {
      console.error('Error releasing invoice:', error);
    } finally {
      setProcessingInvoiceId(null);
    }
  };

  const deleteOrderLogistic = async (logisticId, invoiceId) => {
    try {
      const payload = {
        logisticId: logisticId || null,
        invoiceId: invoiceId || null,
      };
      const resp = await axiosPost(
        `${process.env.REACT_APP_REST_API_ENDPOINT}order/delete-order-logistics`,
        payload,
        {},
        auth,
      );
      if (resp.isSuccessful) {
        toast.success('Order Logistic Delete Successfully');
      }
      return resp.isSuccessful;
    } catch (error) {
      console.error(error);
    } finally {
      refetchOrderData();
    }
  };

  const removeAtIndex = (arr, index) => {
    return arr.filter((_, i) => i !== index)?.map((dt) => ({ ...dt }));
  };

  const handleOrderLogisticsRemove = async (
    orderLogisticId,
    invoiceId,
    ind,
    remove,
  ) => {
    if (orderLogisticId) {
      try {
        const res = await deleteOrderLogistic(orderLogisticId, invoiceId);
        if (res) {
          remove(ind);
          const updatedInvoices = removeAtIndex(values?.invoiceInfo, ind);
          const updatedLogistics = removeAtIndex(values?.orderLogistics, ind);
          setFieldValue('invoiceInfo', updatedInvoices);
          setOrderDraft(values?.id, {
            orderLogistics: updatedLogistics,
            invoiceInfo: updatedInvoices,
          });
        }
      } catch (e) {
        toast.error(e);
      }
    } else {
      remove(ind);
      const updatedInvoices = removeAtIndex(values?.invoiceInfo, ind);
      const updatedLogistics = removeAtIndex(values?.orderLogistics, ind);
      setFieldValue('invoiceInfo', updatedInvoices);
      setOrderDraft(values?.id, {
        orderLogistics: updatedLogistics,
        invoiceInfo: updatedInvoices,
      });
    }
  };

  const handleInvoiceAmountChange = (e, fieldName, ind) => {
    let val = e.target.value.replace(/[^0-9.]/g, '');
    const parts = val.split('.');
    if (parts.length > 1) {
      val = `${parts[0]}.${parts.slice(1).join('').slice(0, 2)}`;
    }
    setFieldValue(fieldName, val, true);
    setFieldValue(`invoiceInfo.${ind}.invoiceDetailsSaved`, false);
  };

  const handleInvoiceAmountKeyDown = (e, currentValue) => {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];

    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
      return;
    }

    if (e.key === '.') {
      const val = String(currentValue ?? '');
      const selectedText = window.getSelection
        ? window.getSelection().toString()
        : '';
      if (val.includes('.') && !selectedText.includes('.')) {
        e.preventDefault();
      }
      return;
    }

    if (/^[0-9]$/.test(e.key)) {
      return;
    }

    e.preventDefault();
  };

  const plusIcon = (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00146 0.249756C4.08435 0.249756 4.16454 0.282948 4.22314 0.341553C4.28163 0.400044 4.31384 0.479553 4.31396 0.562256V3.68726H7.43896C7.52184 3.68726 7.60204 3.72045 7.66064 3.77905C7.71913 3.83754 7.75134 3.91705 7.75146 3.99976C7.75146 4.08264 7.71925 4.16283 7.66064 4.22144C7.60204 4.28004 7.52184 4.31226 7.43896 4.31226H4.31396V7.43726C4.31396 7.52014 4.28175 7.60033 4.22314 7.65894C4.16454 7.71754 4.08435 7.74976 4.00146 7.74976C3.91876 7.74963 3.83925 7.71742 3.78076 7.65894C3.72216 7.60033 3.68896 7.52014 3.68896 7.43726V4.31226H0.563965C0.481262 4.31213 0.401753 4.27992 0.343262 4.22144C0.284657 4.16283 0.251465 4.08264 0.251465 3.99976C0.251591 3.91705 0.284769 3.83755 0.343262 3.77905C0.401755 3.72056 0.481256 3.68738 0.563965 3.68726H3.68896V0.562256C3.68909 0.479547 3.72227 0.400046 3.78076 0.341553C3.83925 0.28306 3.91876 0.249882 4.00146 0.249756Z"
        fill="white"
      />
    </svg>
  );

  return (
    <CardWithTitleAndButton>
      <div>
        {' '}
        <FieldArray name="orderLogistics">
          {({ remove, push }) => (
            <>
              <Row>
                <Col>
                  <h4 className="f-16 mb-3 fw-semibold">Vehicle</h4>
                </Col>
                <Col className="justify-content-end d-flex gap-3">
                  <ButtonV2
                    color="primary"
                    type="button"
                    size="sm"
                    style={{ fontWeight: '400' }}
                    className="border-radius-4"
                    // className="text-decoration-none card-right-btn font-manrope fw-bold f-12 p-0"
                    onClick={() => {
                      const pendingQuantity =
                        values?.quantity -
                        calculatePendingQty(values?.orderLogistics);
                      if (pendingQuantity <= 0) {
                        toast.error('Quantity is empty to fill.');
                        return;
                      }

                      push({
                        id: null,
                        order: values.id,
                        driverName: '',
                        driverNumber: '',
                        vehicle: '',
                        vehicleNumber: '',
                        transportName: '',
                        transportLR: '',
                        loadingCharges: null,
                        otherCharges: null,
                        freight: null,
                        rateUnit: values?.rateUnit?.id,
                        weightSlipDoc: [],
                        lrDoc: [],
                        vehicleNumberImage: [],
                        loadingImage: [],
                        // subTotal: 0,
                        // total: 0,
                        orderLogisticStatus: values?.status,
                        loadingDate: null,
                        dispatchDate: null,
                        deliveryDate: null,
                        loadingQty: '',
                        loadingQtyUnit: values?.quantityUnit?.id,
                        pickupAddress: {
                          houseNumber: '',
                          street: '',
                          area: '',
                          city: '',
                          state: '',
                          country: '',
                          pinCode: '',
                        },
                      });

                      setFieldValue('invoiceInfo', [
                        ...(values?.invoiceInfo || []),
                        {
                          paymentStatus: null,
                          order: values?.id,
                          id: null,
                          invoiceFiles: null,
                          total: null,
                          releasedToUser: null,
                        },
                      ]);
                    }}
                  >
                    {plusIcon}{' '}
                    <span style={{ paddingLeft: '6px' }}>Add Vehicle</span>
                  </ButtonV2>
                </Col>
              </Row>

              {values?.orderLogistics?.map((orderLogistic, ind) => (
                <React.Fragment
                  key={orderLogistic.id || `orderLogistic-${ind}`}
                >
                  <CommonAccordion
                    defaultValue="1"
                    heading={`#Vehicle ${ind + 1}`}
                    key={orderLogistic.id || `orderLogistic-${ind}`}
                    children={
                      <div>
                        <div style={{ padding: '16px' }}>
                          <h5 className="f-14 mb-3 fw-semibold">
                            Driver Details
                          </h5>
                          <Row>
                            <Col sm={6}>
                              {/* <DriverSearch label="Driver Name" name="driver_name" /> */}
                              <Field
                                label="Driver Name"
                                name={`orderLogistics.${ind}.driverName`}
                                type="text"
                                component={FormikInputField}
                                placeholder="Enter Driver Name"
                              />
                            </Col>

                            <Col sm={6}>
                              {/* <Field
                     label="Driver Number"
                     name={`orderLogistics.${ind}.driverNumber`}
                     type="text"
                     component={FormikInputField}
                   /> */}
                              <Row>
                                <Col sm={12}>
                                  <Label>Driver Number</Label>
                                </Col>
                                <CallingCodeField
                                  // id="callingCode"
                                  // name="callingCode"
                                  id={`orderLogistics.${ind}.callingCode`}
                                  name={`orderLogistics.${ind}.callingCode`}
                                  label=""
                                  // required
                                />
                                <Col className="w-100">
                                  <Field
                                    id={`orderLogistics.${ind}.driverNumber`}
                                    name={`orderLogistics.${ind}.driverNumber`}
                                    label=""
                                    type="tel"
                                    component={FormikInputField}
                                    placeholder="Enter Driver Number"
                                    disabled={
                                      !orderLogistic?.callingCode?.id?.length
                                    }
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    maxLength={10}
                                    onChange={(event) => {
                                      setFieldValue(
                                        `orderLogistics.${ind}.driverNumber`,
                                        event.target.value
                                          .replace(/\D/g, '')
                                          .slice(0, 10),
                                        true,
                                      );
                                    }}
                                    onKeyDown={(event) => {
                                      const isNumberKey = /^[0-9]$/.test(
                                        event.key,
                                      );
                                      const allowedKeys = [
                                        'Backspace',
                                        'Delete',
                                        'ArrowLeft',
                                        'ArrowRight',
                                        'Tab',
                                      ];

                                      if (
                                        !isNumberKey &&
                                        !allowedKeys.includes(event.key)
                                      ) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                        <div className="gray-divider" />

                        <div style={{ padding: '16px' }}>
                          <h5 className="f-14 mb-3 fw-semibold">
                            Vehicle Details
                          </h5>

                          <Row>
                            <Col sm={6}>
                              <Field
                                label="Vehicle Number"
                                name={`orderLogistics.${ind}.vehicleNumber`}
                                type="text"
                                component={FormikInputField}
                                required
                                placeholder="Enter Vehicle Number"
                                maxLength={10}
                                onChange={(event) => {
                                  const value =
                                    event.target.value.toUpperCase();
                                  if (isValidVehicleNumberPrefix(value)) {
                                    setFieldValue(
                                      `orderLogistics.${ind}.vehicleNumber`,
                                      value,
                                      true,
                                    );
                                  }
                                }}
                                onPaste={(event) => {
                                  event.preventDefault();
                                  const value = event.clipboardData
                                    .getData('text')
                                    .toUpperCase();
                                  if (isValidVehicleNumberPrefix(value)) {
                                    setFieldValue(
                                      `orderLogistics.${ind}.vehicleNumber`,
                                      value,
                                      true,
                                    );
                                  }
                                }}
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                label="Transport Name"
                                name={`orderLogistics.${ind}.transportName`}
                                type="text"
                                component={FormikInputField}
                                placeholder="Enter Transport Name"
                              />
                            </Col>
                            {/* {console.log(
                    'first',
                    values?.orderLogistics?.[ind]?.vehicleNumberImage?.length
                  )} */}
                            <Col sm={6}>
                              {values?.orderLogistics?.[ind]?.vehicleNumberImage
                                ?.length ? (
                                <EditUploadWrapper
                                  name={`orderLogistics.${ind}.vehicleNumberImage`}
                                  label="Vehicle Number Image"
                                  required
                                  fileName={
                                    values?.orderLogistics?.[ind]
                                      ?.vehicleNumberImage
                                  }
                                  handleCancel={() => {
                                    setFieldValue(
                                      `orderLogistics.${ind}.vehicleNumberImage`,
                                      '',
                                    );
                                  }}
                                />
                              ) : (
                                <S3FileUploadField
                                  label="Vehicle Number Image"
                                  name={`orderLogistics.${ind}.vehicleNumberImage`}
                                  pathUrl="images/order_logistics/vehicle_number"
                                  required
                                  accept=".png, .jpg, .jpeg"
                                  multiple
                                  // {...rest}
                                  // pathUrl={`traders/${auth?.data?.userId}/logistic/vehicleNumber`}
                                />
                              )}
                            </Col>

                            <Col sm={6}>
                              {values?.orderLogistics?.[ind]?.weightSlipDoc
                                ?.length ? (
                                <EditUploadWrapper
                                  label="Weight Slip (image)"
                                  name={`orderLogistics.${ind}.weightSlipDoc`}
                                  fileName={
                                    values?.orderLogistics?.[ind]?.weightSlipDoc
                                  }
                                  handleCancel={() => {
                                    setFieldValue(
                                      `orderLogistics.${ind}.weightSlipDoc`,
                                      '',
                                    );
                                  }}
                                />
                              ) : (
                                <S3FileUploadField
                                  label="Weight Slip (image)"
                                  name={`orderLogistics.${ind}.weightSlipDoc`}
                                  pathUrl="images/order_logistics/weight_slips"
                                  accept=".png, .jpg, .jpeg"

                                  // pathUrl={`traders/${auth?.data?.userId}/logistic/weightSlip`}
                                />
                              )}
                            </Col>

                            {/* <Col sm={12}>
                    {values?.orderLogistics?.[ind]?.lrDoc?.length ? (
                      <EditUploadWrapper
                        name={`orderLogistics.${ind}.lrDoc`}
                        label="LR (image)"
                        fileName={values?.orderLogistics?.[ind]?.lrDoc}
                        handleCancel={() => {
                          rest.setFieldValue(
                            `orderLogistics.${ind}.lrDoc`,
                            '',
                          );
                        }}
                      />
                    ) : (
                      <S3FileUploadField
                        label="LR (image)"
                        name={`orderLogistics.${ind}.lrDoc`}
                        pathUrl="images/order_logistics/lr_docs"
                        accept=".png, .jpg, .jpeg, .pdf"

                        // pathUrl={`traders/${auth?.data?.userId}/logistic/lrDoc`}
                      />
                    )}
                  </Col> */}
                            <Col sm={6}>
                              {values?.orderLogistics?.[ind]?.loadingImage
                                ?.length ? (
                                <EditUploadWrapper
                                  name={`orderLogistics.${ind}.loadingImage`}
                                  label="Loading (image)"
                                  required
                                  fileName={
                                    values?.orderLogistics?.[ind]?.loadingImage
                                  }
                                  handleCancel={() => {
                                    setFieldValue(
                                      `orderLogistics.${ind}.loadingImage`,
                                      '',
                                    );
                                  }}
                                />
                              ) : (
                                <S3FileUploadField
                                  label="Loading (image)"
                                  name={`orderLogistics.${ind}.loadingImage`}
                                  // pathUrl={`traders/${auth?.data?.userId}/logistic/loadingImage`}
                                  pathUrl="images/order_logistics/loading_images"
                                  required
                                  accept=".png, .jpg, .jpeg, .pdf"
                                  multiple
                                />
                              )}
                            </Col>

                            <Col sm={6}>
                              <Field
                                label="Transport LR"
                                name={`orderLogistics.${ind}.transportLR`}
                                type="text"
                                component={FormikInputField}
                              />
                            </Col>
                          </Row>
                        </div>
                        <div className="gray-divider" />
                        <div style={{ padding: '16px' }}>
                          <div className="quantity-title-container">
                            <h5 className="f-14 mb-3 fw-semibold">
                              Quantity Details
                            </h5>
                            <div>
                              <small className="text-danger text-nowrap f-14 mb-2 d-block">
                                Total Quantity:{' '}
                                <strong>
                                  {values?.quantity?.toLocaleString()}
                                  {values?.quantityUnit?.label}
                                </strong>{' '}
                                Pending Quantity:{' '}
                                <strong>
                                  {' '}
                                  {(
                                    values?.quantity -
                                    calculatePendingQty(values?.orderLogistics)
                                  )?.toLocaleString()}
                                  {values?.quantityUnit?.label}
                                </strong>
                              </small>
                            </div>
                          </div>
                          <Row>
                            <Col sm={6}>
                              <Row>
                                <Col sm={8}>
                                  <Field
                                    label="Loading Quantity"
                                    name={`orderLogistics.${ind}.loadingQty`}
                                    type="number"
                                    step="any"
                                    component={FormikInputField}
                                    placeholder="Enter Quantity"
                                    required
                                  />
                                  {/* <ErrorMessage name="orderLogistics" render={(msg) => {
                         return <div className="text-danger text-nowrap f-14 mb-2 ">{msg}</div>;
                       }} /> */}
                                </Col>
                                <Col sm={4} className="unit-column">
                                  <Input
                                    // disabled={
                                    //   !values?.orderLogistics?.[ind]?.loadingQty
                                    // }
                                    disabled
                                    className="ps-0 shadow-none f-14 fw-normal"
                                    id={`orderLogistics.${ind}.loadingQtyUnit`}
                                    name={`orderLogistics.${ind}.loadingQtyUnit`}
                                    type="select"
                                    value="MT"
                                    onChange={handleChange}
                                  >
                                    <option value="KG">KG</option>
                                    <option value="MT">MT</option>
                                  </Input>
                                  {/* <ErrorMessage name={`orderLogistics.${ind}.loadingQtyUnit`} render={(msg) => {
                         return <div className="text-danger text-nowrap f-14 mb-2 ">{msg}</div>;
                       }} /> */}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>

                        <div className="gray-divider" />
                        <div style={{ padding: '16px' }}>
                          <h5 className="f-14 mb-3 fw-semibold">
                            Delivery Updates
                          </h5>
                          <Row>
                            <Col sm={6}>
                              <DeliveryField
                                ind={ind}
                                values={values}
                                handleChange={handleChange}
                                label="Delivery Status"
                                required
                              />
                            </Col>

                            <Col sm={5}>
                              <Field
                                label="Delivery Date"
                                name={`orderLogistics.${ind}.deliveryDate`}
                                type="text"
                                component={FormikDatePicker}
                                dateFormat="dd/MM/yyyy"
                                minDate={
                                  values?.createdAt
                                    ? new Date(
                                        typeof values.createdAt === 'number' &&
                                          values.createdAt < 100000000000
                                          ? values.createdAt * 1000
                                          : values.createdAt,
                                      )
                                    : undefined
                                }
                              />
                            </Col>
                          </Row>
                        </div>

                        <div className="gray-divider" />
                        <div style={{ padding: '16px' }}>
                          <div className="d-flex align-items-center justify-content-between">
                            <h5 className="f-14 mb-3 fw-semibold">
                              Invoice Details
                            </h5>
                            <div>
                              {values?.invoiceInfo?.[ind]?.id &&
                                values?.invoiceInfo?.[ind]?.invoiceFiles
                                  ?.length > 0 &&
                                !values?.invoiceInfo?.[ind]?.releasedToUser && (
                                  <ButtonV2
                                    className="border-radius-4"
                                    size="sm"
                                    color="warning"
                                    type="button"
                                    disabled={
                                      sectionSaving === ind ||
                                      values?.invoiceInfo?.[ind]
                                        ?.invoiceDetailsSaved === false
                                    }
                                    onClick={() =>
                                      releaseInvoice(
                                        values?.invoiceInfo?.[ind]?.id,
                                        ind,
                                      )
                                    }
                                  >
                                    {cloudIcon}
                                    <span style={{ marginLeft: '6px' }}>
                                      {values?.invoiceInfo?.[ind]?.id ===
                                      processingInvoiceId
                                        ? 'Releasing...'
                                        : 'Release to User'}
                                    </span>
                                  </ButtonV2>
                                )}
                              {values?.invoiceInfo?.[ind]?.releasedToUser && (
                                <ButtonV2
                                  size="sm"
                                  style={{
                                    height: '27px',
                                    background: '#FFF7DB',
                                    padding: '6px',
                                    color: '#212529',
                                    border: 'none',
                                    outline: 'none',
                                  }}
                                  type="button"
                                >
                                  {doneCloudIcon}
                                  <span style={{ marginLeft: '6px' }}>
                                    Released to User
                                  </span>
                                </ButtonV2>
                              )}
                            </div>
                          </div>
                          <Row>
                            <Col sm={6}>
                              <Field
                                id={`invoiceInfo.${ind}.total`}
                                name={`invoiceInfo.${ind}.total`}
                                type="text"
                                label="Invoice Amount"
                                component={FormikInputField}
                                placeholder="Enter Invoice Amount"
                                inputMode="decimal"
                                onChange={(e) =>
                                  handleInvoiceAmountChange(
                                    e,
                                    `invoiceInfo.${ind}.total`,
                                    ind,
                                  )
                                }
                                onKeyDown={(e) =>
                                  handleInvoiceAmountKeyDown(
                                    e,
                                    values?.invoiceInfo?.[ind]?.total,
                                  )
                                }
                              />
                            </Col>
                            <Col sm={6}>
                              <Field
                                label={<>Payment Status</>}
                                name={`invoiceInfo.${ind}.paymentStatus`}
                                type="select"
                                component={ReactSelect}
                                data={[
                                  {
                                    id: 'PENDING',
                                    label: 'Pending',
                                  },
                                  {
                                    id: 'PAID',
                                    label: 'Paid',
                                  },
                                ]}
                                keys={{ id: 'id', label: 'label' }}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.label}
                                value={
                                  values?.invoiceInfo?.[ind]?.paymentStatus
                                }
                                onChange={() =>
                                  setFieldValue(
                                    `invoiceInfo.${ind}.invoiceDetailsSaved`,
                                    false,
                                  )
                                }
                                placeholder="Select Status"
                              />
                            </Col>
                            <Col sm={6}>
                              {values?.invoiceInfo?.[ind]?.invoiceFiles
                                ?.length ? (
                                <EditUploadWrapper
                                  name={`invoiceInfo.${ind}.invoiceFiles`}
                                  label="Invoice File"
                                  required
                                  fileName={
                                    Array.isArray(
                                      values?.invoiceInfo?.[ind]?.invoiceFiles,
                                    )
                                      ? values?.invoiceInfo?.[ind]
                                          ?.invoiceFiles?.[0]
                                      : values?.invoiceInfo?.[ind]?.invoiceFiles
                                  }
                                  handleCancel={() => {
                                    setFieldValue(
                                      `invoiceInfo.${ind}.invoiceFiles`,
                                      null,
                                    );
                                    setFieldValue(
                                      `invoiceInfo.${ind}.invoiceDetailsSaved`,
                                      false,
                                    );
                                  }}
                                />
                              ) : (
                                <S3FileUploadField
                                  label="Invoice File"
                                  name={`invoiceInfo.${ind}.invoiceFiles`}
                                  pathUrl="images/order_logistics/vehicle_number"
                                  accept=".png, .jpg, .jpeg, .pdf"
                                  multiple
                                  required
                                  onUploadSuccess={(urls) =>
                                    handleInvoiceFileUpload(ind, urls)
                                  }
                                />
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <div style={{ textAlign: 'right' }}>
                              <ButtonV2
                                color="danger"
                                type="button"
                                outline
                                className="py-1 rounded-0 f-14 ms-2 border-radius-4"
                                onClick={() =>
                                  handleOrderLogisticsRemove(
                                    orderLogistic?.id,
                                    values?.invoiceInfo?.find(
                                      (invoice) =>
                                        String(invoice?.logisticId) ===
                                        String(orderLogistic?.id),
                                    )?.id,
                                    ind,
                                    remove,
                                  )
                                }
                              >
                                Remove
                              </ButtonV2>
                              <ButtonV2
                                color="primary"
                                key="update-charges"
                                size="sm"
                                style={{
                                  marginLeft: '10px',
                                }}
                                onClick={() => onClickSave(ind)}
                                disabled={sectionSaving === ind}
                                className="border-radius-4"
                              >
                                {sectionSaving === ind ? 'Saving' : 'Save'}
                              </ButtonV2>
                            </div>
                          </Row>
                        </div>
                      </div>
                    }
                  />
                  <div style={{ marginTop: '5px' }} />
                </React.Fragment>
              ))}
            </>
          )}
        </FieldArray>
      </div>
    </CardWithTitleAndButton>
  );
};

export default OrderLogistics;
